import deviceDetector from '@/services/device-detector'
import { app, firebasePerformance } from '@/main.js'
import { trace } from 'firebase/performance'
import md5 from 'js-md5'

const MOBILE_DEVICES_POSTFIX = 'Mobile'

export default {
  sendStandardMarkupEvent: ({ rootState }, data) =>
    new Promise(() => {
      const gtm = app.config.globalProperties.$gtm
      gtm.trackEvent({
        event: 'standard-markup-event',
        markup_block: data.block,
        markup_element: data.element,
        markup_action: data.action,
        markup_action_details: data.details,
        markup_action_value: data.value,
        markup_force_exponea_event: Boolean(data.exponea),
        markup_disable_amplitude_event: Boolean(data.disableAmplitude),
      })
    }),
  singleEvent: ({ rootState }, eventInfo) => {
    let event = eventInfo
    let data = null
    if (typeof eventInfo === 'object') {
      event = eventInfo.event
      data = eventInfo.data
    }
    const gtm = app.config.globalProperties.$gtm
    gtm.trackEvent({
      event,
      event_data: data,
    })
    gtm.trackEvent({
      event: 'standard-markup-event',
      markup_block: 'meta',
      markup_element: 'meta',
      markup_action: event,
      markup_action_details: '',
      markup_action_value: '',
    })
  },
  sendAbTestVariation: ({ rootState }, data) => {
    const gtm = app.config.globalProperties.$gtm
    gtm.trackEvent({
      event: 'ab_test_variation',
      ab_test_name: data.testName,
      ab_test_variation_key: data.variationKey,
      ab_test_dimension_index: data.dimensionIndex,
    })
  },
  initializeYandexABFlagsEvent: ({ rootState }, data) => {
    const gtm = app.config.globalProperties.$gtm
    for (const [key, value] of Object.entries(data)) {
      const eventValue = Array.isArray(value) ? value[0] : value
      gtm.trackEvent({
        event: 'standard-markup-event',
        'eventInfo.eventCategory': 'ABTesting',
        'eventInfo.eventLabel': key,
        'eventInfo.eventValue': eventValue,
        eventInfo: {
          eventCategory: 'ABTesting',
          eventLabel: key,
          eventValue: eventValue,
        },
        markup_block: 'meta',
        markup_element: 'meta',
        markup_action: '‘ABTesting’Init',
        markup_action_details: '',
        markup_action_value: eventValue,
      })
    }
  },
  trackActiveTestsWithVariations: ({ rootState }, tests) => {
    const gtm = app.config.globalProperties.$gtm
    gtm.trackEvent({
      event: 'track_active_tests',
      active_tests_with_variations: JSON.stringify(tests),
    })
  },
  firebasePerformanceCustomTraceStart: ({ commit, getters }, name) => {
    const traceName = deviceDetector.isSmartphone ? name + MOBILE_DEVICES_POSTFIX : name
    // Именно в window должен лежать т.к. с реактивносью ломается
    if (!window.firebasePerformanceCustomTraces) {
      window.firebasePerformanceCustomTraces = {}
    }
    if (!window.firebasePerformanceCustomTraces[traceName]) {
      const customTrace = trace(firebasePerformance, traceName)
      customTrace.start()
      window.firebasePerformanceCustomTraces[traceName] = customTrace
    }
  },
  firebasePerformanceCustomTraceStop: ({ commit, getters }, name) => {
    const traceName = deviceDetector.isSmartphone ? name + MOBILE_DEVICES_POSTFIX : name

    if (!window.firebasePerformanceCustomTraces) {
      window.firebasePerformanceCustomTraces = {}
    }
    if (window.firebasePerformanceCustomTraces[traceName]) {
      window.firebasePerformanceCustomTraces[traceName].stop()
      window.firebasePerformanceCustomTraces[traceName] = null
    }
  },
  firebasePerformanceCustomTraceStopByPrefix (name) {
    if (!window.firebasePerformanceCustomTraces) {
      window.firebasePerformanceCustomTraces = {}
    }

    const traces = Object.keys(window.firebasePerformanceCustomTraces).filter(v => v.includes(name))

    if (!traces.length) {
      return
    }

    traces.forEach((name) => {
      window.firebasePerformanceCustomTraces[name].stop()
      window.firebasePerformanceCustomTraces[name] = null
    })
  },
  // Устанавливаем GTM User ID
  setUserId: ({ rootState }, client) => {
    const gtm = app.config.globalProperties.$gtm
    const clientInfo = client || rootState.client.profile
    gtm.trackEvent({
      event: 'user_id_set',
      user_id: clientInfo.id_H,
      phone_md5: md5(clientInfo.phone),
      active_orders_count: clientInfo.activeOrdersCount,
      activity_status: clientInfo.activityStatus,
      city_id: clientInfo.cityId,
      user_email: clientInfo.email,
      user_first_name: clientInfo.first_name,
      user_last_name: clientInfo.last_name,
    })
  },
}
